export default __webpack_public_path__ + "static/media/8_1.0dc893da.png";